export const messageBubbleTypes = {
  text: 'text',
  link: 'link',
  postBack: 'postBack',
  image: 'image',
}
